import {createTransport} from '@sentry/core';
import * as Sentry from '@sentry/browser';
import {captureConsoleIntegration} from '@sentry/browser';
import {getCsrfToken, getCsrfTokenHeaderName} from "./lib/utils.js";
import {sentryBeforeSend} from "./lib/telemetry/sentryBeforeSend.js";

function makeFetchTransport(options) {
    function makeRequest(request) {
        let csrfToken = getCsrfToken();
        let csrfTokenHeaderName = getCsrfTokenHeaderName();
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: {
                [csrfTokenHeaderName]: csrfToken,
                ...options.headers
            },
            ...options.fetchOptions,
        };

        return fetch('/api/telemetry', requestOptions).then(response => {
            return {
                statusCode: response.status,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After'),
                },
            };
        });
    }

    return createTransport(options, makeRequest);
}

const env = import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local';
const dsn = import.meta.env.VITE_SENTRY_DSN;
Sentry.init({
    sampleRate: 1,
    environment: env,
    attachStacktrace: true,
    dsn,
    transport: makeFetchTransport,
    integrations: (defaults = []) => [
        ...defaults,
        captureConsoleIntegration({levels: ['error']}),
    ],
    // Filter browser extension errors by message and URL patterns
    ignoreErrors: [
        // Chrome/Safari extension errors
        'runtime.sendMessage',
        'chrome-extension://',
        'moz-extension://',
        'safari-extension://',
        // Common extension-related errors
        /Extension context invalidated/i,
        /Cannot access a chrome:\/\//i,
        /Cannot access a moz-extension:\/\//i,
        /Cannot access a safari-extension:\/\//i,
        // Extension message passing errors
        'Tab not found',
        /Attempting to use a disconnected port object/i,
        /The message port closed before a response was received/i,
    ],
    beforeSend: sentryBeforeSend,
});

if (typeof window !== 'undefined') {
    // expose Sentry for console debugging (includes getCurrentHub on namespace)
    window.Sentry = Sentry;
}
